import script from "./ManageGlobalGroupSettingsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageGlobalGroupSettingsTab.vue?vue&type=script&setup=true&lang=js"

import "./ManageGlobalGroupSettingsTab.vue?vue&type=style&index=0&id=a805d978&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a805d978"]])

export default __exports__